<template>
  <div style="width: 100em">
    <ion-header>
      <ion-toolbar>
        <ion-title>Course Details</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <!--    <ion-list>-->
      <ion-item>
        <div fxFlex="column">
          <h5>{{ course.name }}</h5>
          <h6>{{ course.university }},{{ course.city }}</h6>
          <p v-for="d of (course.details || '').split('\n')" v-bind:key="d">
            {{ d }}
          </p>
        </div>
      </ion-item>
    </ion-content>

    <ion-footer>
    </ion-footer>
  </div>
</template>

<script>
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonFooter,
  IonContent,
  IonItem,
} from '@ionic/vue';


export default {
  name: 'CourseDetail',
  components: {
    IonHeader,
    IonToolbar,
    IonTitle,
    IonFooter,
    IonContent,
    IonItem
  },
  data() {
    return {
    };
  },
  props: {
    course: {type: Object}
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style>

</style>
